/** Deterministic hash-based jitter so overlapping dots spread out */
export const jitter = (seed: string, amount = 0.02): number => {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  return ((hash % 1000) / 1000) * amount * 2 - amount;
};
